import React from 'react'
import { PieChart } from 'react-minimal-pie-chart'
import './CrossClientProgress.scss'

export interface CrossClientProgressProps {
  total: number
  done: number
  className?: string
  showPercentage?: boolean
  lineWidth?: number
  doneColor?: string
}

export const CrossClientProgress: React.FC<CrossClientProgressProps> = ({
  total,
  done,
  className,
  showPercentage = false,
  lineWidth = 30,
  doneColor = 'var(--zocks-primary)',
}) => {
  const effectiveTotal = total > 0 ? total : Math.max(done, 1)
  const remaining = Math.max(effectiveTotal - done, 0)
  const percentage = showPercentage && total > 0 ? Math.floor((done / total) * 100) : null

  return (
    <div className={`d-flex flex-column align-items-center justify-content-center position-relative ${className ?? ''}`}>
      <PieChart
        data={[
          { title: 'Done', value: done, color: doneColor },
          { title: 'Total', value: remaining, color: '#E9ECEF' },
        ]}
        lineWidth={lineWidth}
        totalValue={effectiveTotal}
        startAngle={270}
      />
      {percentage ? (
        percentage >= 100 ? (
          <i className='bi bi-check-lg zocks-text-primary fs-4 position-absolute' />
        ) : (
          <div className='paragraph-medium medium position-absolute'>{percentage}%</div>
        )
      ) : null}
    </div>
  )
}
